import { render, staticRenderFns } from "./RbacUser.vue?vue&type=template&id=07b63904&scoped=true&"
import script from "./RbacUser.vue?vue&type=script&lang=js&"
export * from "./RbacUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b63904",
  null
  
)

export default component.exports